<template>
  <div>
    <div class="tabsBox">
      <van-tabs
        v-model="active"
        class="meusTabs"
        animated
        sticky
        offset-top="1.2rem"
        lazy-render	
      >
        <van-tab
          v-for="item in meusList"
          :key="item"
          :title="item"
        />
      </van-tabs>
    </div>
    <div class="data_box">
      <div class="top_data_box">
        <div
          v-for="item in dataParams"
          :key="item.key"
          class="data_item"
        >
          <div class="title">
            {{ item.title }}
          </div>
          <div class="count">
            {{ data[item.key] === 0 || data[item.key] ? data[item.key] : '-' }}
          </div>
        </div>
        <div class="bottom_data_box">
          <div class="title">
            Visão Geral dos Dados
          </div>
          <div
            v-for="item in dataList"
            :key="item.title"
            class="data_row_box"
          >
            <div
              class="data_row_title"
              @click="changeActive(item.active)"
            >
              {{ item.title }}
            </div>
            <div class="data_col_box">
              <div
                v-for="citem in item.colList"
                :key="citem.title"
                class="data_col"
              >
                <div class="data_col_title">
                  {{ citem.title }}
                </div>
                <div class="data_col_count">
                  {{ data[citem.key] || data[citem.key] === 0 ? data[citem.key] : '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs  } from 'vant';
import Fetch from '../../../utils/fetch';
export default {
    components: { 
        vanTab: Tab,
        vanTabs: Tabs,
    },
    data() {
        return {
            active: 0,
            data: {},
            meusList: ['Ontem', 'Hoje', 'Está Semana', 'Última Semana', 'Este mês', 'Mês Passado'],
            dataParams: [
                {
                    title: 'Adicionar membros diretos',
                    key: 'directlyRegNum'
                },
                {
                    title: 'Primeiros Depósitos',
                    key: 'directlyFirstRechNum'
                },
                {
                    title: 'Depósitos',
                    key: 'directlyRechNum'
                },
                {
                    title: 'Depósitos',
                    key: 'directlyRechAmount'
                },
                {
                    title: 'Desempenho',
                    key: 'directlyValidAmount'
                },
                {
                    title: 'Comissão',
                    key: 'personalCommAmount'
                },
            ],
            dataList: [
                {
                    title: 'Meu Time',
                    active: 5,
                    colList: [
                        {
                            title: 'Membros',
                            key: 'allSubNumber'
                        },
                        {
                            title: 'Membros Diretos',
                            key: 'directlySubNumber'
                        },
                        {
                            title: 'Outros Membros',
                            key: 'otherSubNumber'
                        },
                    ]
                },
                {
                    title: 'Desempenho',
                    active: 3,
                    colList: [
                        {
                            title: 'Rendimento Total',
                            key: 'allVaildAmount'
                        },
                        {
                            title: 'D. Direto',
                            key: 'directlyVaildAmount'
                        },
                        {
                            title: 'D. dos Outros',
                            key: 'otherVaildAmount'
                        },
                    ]
                },
                {
                    title: 'Comissão',
                    active: 4,
                    colList: [
                        {
                            title: 'Comissão Total',
                            key: 'allCommissionAmount'
                        },
                        {
                            title: 'Comissão Direta',
                            key: 'directlyCommissionAmount'
                        },
                        {
                            title: 'Outra Comissão',
                            key: 'otherCommissionAmount'
                        },
                    ]
                },
            ]
        }
    },
    watch: {
        active(newval) {
            this.getList(newval + 1)
        }
    },
    created() {
        this.getList()
    },  
    methods: {
        getList(timeType) {
            Fetch('/agent/myData', {
                timeType: timeType || 1
            }).then(res => {
                this.data = res.data
            })
        },
        changeActive(key) {
            this.$emit('changeActive', key)
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../assets/css/variables.less';

.tabsBox {
    background-color: @secondary-color;
    padding: 0.2rem 0.2rem 0.1rem;
    :deep(.van-tab) {
        border: 1px solid @third-color;
        border-radius: 1rem;
        padding: 0 0.3rem !important;
        margin: 0 0.1rem;
        height: 0.7rem;
        &.van-tab--active {
            background-color: @rechargeColor;
            span {
                color: @primary-color !important;
            }
        }
    } 
    :deep(.van-tabs__line) {
        display: none;
    }
}
.data_box {
    margin-top: 0.1rem;
    padding: 0.2rem;
    .top_data_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .data_item {
            width: 31.5%;
            height: 2rem;
            background-color: @secondary-color;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: @textcolor1;
            font-size: 0.32rem;
            text-align: center;
            margin-bottom: 0.28rem;
            border-radius: 0.2rem;
            padding: 0.2rem;
            box-sizing: border-box;
            box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06);
            .title {
                margin-bottom: 0.36rem;
            }
            .count {
                font-size: 0.46rem;
                color: @textcolorf;
            }
            &:last-child {
                .count {
                    color: @rechargeColor;
                }
            }
        }
    }
    .bottom_data_box {
        // margin-top: 0.12rem;
        width: 100%;
        border-radius: 0.2rem;
        background-color: @secondary-color;
        .title {
            color: @textcolorf;
            padding: 0 0.2rem;
            height: 1.07rem;
            line-height: 1.07rem;
            border-bottom: 1px solid @bodercolor;
        }
        .data_row_box {
            padding: 0 0.2rem;
            .data_col_box {
                display: flex;
                border-bottom: 1px solid @bodercolor;
            }
            &:last-child {
                .data_col_box {
                    border-bottom: none;
                }
                .data_col_count {
                    color: @anttextcolor !important;
                }
            }
            .data_row_title {
                position: relative;
                height: 0.8rem;
                line-height: 0.8rem;
                color: @textcolor1;
                text-align: center;
                border-bottom: 1px solid @bodercolor;
                &::before {
                    content: '';
                    border-color: @textcolor1;
                    border-style: solid;
                    border-width: .01rem .01rem 0 0;
                    content: "";
                    display: block;
                    height: .15rem;
                    position: absolute;
                    right: .2rem;
                    top: 50%;
                    transform: translate(-50%, -50%) rotate(45deg);
                    width: .15rem;
                }
            }
            .data_col {
                position: relative;
                width: 32%;
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 1.2rem;
                padding: 0.2rem 0;
                font-size: 0.32rem;
                color: @textcolor1;
                .data_col_count {
                    margin-top: 0.32rem;
                    color: @textcolorf;
                }
                &::before {
                    content: '';
                    width: 1px;
                    height: 40px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background-color: @third-color;
                }
                &:last-child {
                    &::before {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>